import { resolve } from 'core-js/library/es6/promise';
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router);

export default new Router({
	//mode: 'history',
	scrollBehavior(to, from, savePosition) {
		if (savePosition) {
			return savePosition
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	},
	routes: [{
			path: '*',
			redirect: '/scanqrcode'
		},
		//中文
		{
			path: '/chinese/stepOne',
			name: 'Chinastepone',
			component: resolve => require(['@/pages/chinese/stepOne'], resolve),
			meta: {
				title: '检测组件',
				requireAuth: true
			}
		}, //中文第一步
		{
			path: '/chinese/stepTwo',
			name: 'Chinasteptwo',
			component: resolve => require(['@/pages/chinese/stepTwo'], resolve),
			meta: {
				title: '检测准备',
				requireAuth: true
			}
		}, //中文第二步
		{
			path: '/chinese/stepThree',
			name: 'Chinastepthree',
			component: resolve => require(['@/pages/chinese/stepThree'], resolve),
			meta: {
				title: '步骤 1: 样本采集',
				requireAuth: true
			}
		}, //中文第三步
		{
			path: '/chinese/stepFour',
			name: 'Chinastepfour',
			component: resolve => require(['@/pages/chinese/stepFour'], resolve),
			meta: {
				title: '步骤 2: 样本处理',
				requireAuth: true
			}
		}, //中文第四步
		{
			path: '/chinese/stepFive',
			name: 'Chinastepfive',
			component: resolve => require(['@/pages/chinese/stepFive'], resolve),
			meta: {
				title: '步骤 3: 添加样本',
				requireAuth: true
			}
		}, //中文第五步
		{
			path: '/chinese/stepSix',
			name: 'Chinastepsix',
			component: resolve => require(['@/pages/chinese/stepSix'], resolve),
			meta: {
				title: '倒计时',
				requireAuth: true
			}
		}, //中文第六步
		{
			path: '/chinese/stepSeven',
			name: 'Chinastepseven',
			component: resolve => require(['@/pages/chinese/stepSeven'], resolve),
			meta: {
				title: '步骤 4: 读取结果',
				requireAuth: true
			}
		}, //中文第七步
		{
			path: '/chinese/stepEight',
			name: 'Chinastepeight',
			component: resolve => require(['@/pages/chinese/stepEight'], resolve),
			meta: {
				title: '判读结果',
				requireAuth: true
			}
		}, //中文第八步
		{
			path: '/chinese/manual',
			name: 'Chinamanual',
			component: resolve => require(['@/pages/chinese/manual'], resolve),
			meta: {
				title: '使用说明',
				requireAuth: true
			}
		},
		{
			path:'/chinese/notice',
			name:'Chinanotice',
			component:resolve => require(['@/pages/chinese/notice'],resolve),
			meta:{
				title:'通知',
				requireAuth:true
			}
		},
		{
			path: '/chinese/stepNight',
			name: 'Chinastepnight',
			component: resolve => require(['@/pages/chinese/stepNight'], resolve),
			meta: {
				title: '常见问题',
				requireAuth: true
			}
		}, //中文检测结果
		//英语
		{
			path: '/agreement',
			name: 'Agreement',
			component: resolve => require(['@/pages/agreement'], resolve),
			meta: {
				title: 'TestHelper',
				requireAuth: true
			}
		}, //用户协议
		{
			path: '/privacy',
			name: 'Privacy',
			component: resolve => require(['@/pages/privacy'], resolve),
			meta: {
				title: 'TestHelper',
				requireAuth: true
			}
		}, //隐私政策
		{
			path: '/testresult',
			name: 'Testresult',
			component: resolve => require(['@/pages/testresult'], resolve),
			meta: {
				title: 'USER INSTRUCTION',
				requireAuth: true
			}
		}, //检测结果说明
		{
			path: '/scanqrcode',
			name: 'Scanqrcode',
			component: resolve => require(['@/pages/scanqrcode'], resolve),
			meta: {
				title: '',
				requireAuth: true
			}
		}, //扫描二维码
		{
			path: '/countdown',
			name: 'Countdown',
			component: resolve => require(['@/pages/countdown'], resolve),
			meta: {
				title: 'TIMER',
				requireAuth: true
			}
		}, //倒计时
		{
			path: '/stepone',
			name: 'Stepone',
			component: resolve => require(['@/pages/stepone'], resolve),
			meta: {
				title: 'TEST COMPONENTS',
				requireAuth: true
			}
		}, //检测步骤1
		{
			path: '/steptwo',
			name: 'Steptwo',
			component: resolve => require(['@/pages/steptwo'], resolve),
			meta: {
				title: 'TEST PREPARATION',
				requireAuth: true
			}
		}, //检测步骤2
		{
			path: '/stepthree',
			name: 'Stepthree',
			component: resolve => require(['@/pages/stepthree'], resolve),
			meta: {
				title: 'STEP 1: COLLECT SAMPLE',
				requireAuth: true
			}
		}, //检测步骤3
		{
			path: '/stepfour',
			name: 'Stepfour',
			component: resolve => require(['@/pages/stepfour'], resolve),
			meta: {
				title: 'STEP 2: PROCESS SAMPLE',
				requireAuth: true
			}
		}, //检测步骤4
		{
			path: '/stepfive',
			name: 'Stepfive',
			component: resolve => require(['@/pages/stepfive'], resolve),
			meta: {
				title: 'STEP 3: ADD SAMPLE',
				requireAuth: true
			}
		}, //检测步骤5
		{
			path: '/checkresult',
			name: 'Checkresult',
			component: resolve => require(['@/pages/checkresult'], resolve),
			meta: {
				title: 'STEP 4: READ RESULT',
				requireAuth: true
			}
		}, //选择结果
		{
			path: '/result',
			name: 'Result',
			component: resolve => require(['@/pages/testres'], resolve),
			meta: {
				title: 'RESULT',
				requireAuth: true
			}
		}, //检测结果
		{
			path: '/note',
			name: 'NOTE',
			component: resolve => require(['@/pages/note'], resolve),
			meta: {
				title: 'NOTE',
				requireAuth: true
			}
		}, //检测说明
		{
			path: '/important',
			name: 'Important',
			component: resolve => require(['@/pages/stepStart'], resolve),
			meta: {
				title: 'Important',
				requireAuth: true
			}
		}, //检测前步骤
		{
			path: '/stepend',
			name: 'StepEnd',
			component: resolve => require(['@/pages/stepEnd'], resolve),
			meta: {
				title: 'FREQUENTLY ASKED QUESTIONS',
				requireAuth: true
			}
		}, //检测最后
		//{path: '/delete', name: 'Delete', component: resolve => require(['@/pages/delete'], resolve), meta: {title: 'TestHelper', requireAuth: true}},  //回收站
		//西班牙语
		{
			path: '/spain/stepOne',
			name: 'Spainstepone',
			component: resolve => require(['@/pages/spain/stepOne'], resolve),
			meta: {
				title: 'COMPONENTES DE LA PRUEBA',
				requireAuth: true
			}
		}, //西班牙语第一步
		{
			path: '/spain/stepTwo',
			name: 'Spainsteptwo',
			component: resolve => require(['@/pages/spain/stepTwo'], resolve),
			meta: {
				title: 'PREPARACIÓN DE LA PRUEBA',
				requireAuth: true
			}
		}, //西班牙语第二步
		{
			path: '/spain/stepThree',
			name: 'Spainstepthree',
			component: resolve => require(['@/pages/spain/stepThree'], resolve),
			meta: {
				title: 'PASO 1: RECOLECTAR LA MUESTRA',
				requireAuth: true
			}
		}, //西班牙语第三步
		{
			path: '/spain/stepFour',
			name: 'Spainstepfour',
			component: resolve => require(['@/pages/spain/stepFour'], resolve),
			meta: {
				title: 'PASO 2: PROCESAR LA MUESTRA',
				requireAuth: true
			}
		}, //西班牙语第四步
		{
			path: '/spain/stepFive',
			name: 'Spainstepfive',
			component: resolve => require(['@/pages/spain/stepFive'], resolve),
			meta: {
				title: 'PASO 3: AÑADIR LA MUESTRA',
				requireAuth: true
			}
		}, //西班牙语第五步
		{
			path: '/spain/stepSix',
			name: 'Spainstepsix',
			component: resolve => require(['@/pages/spain/stepSix'], resolve),
			meta: {
				title: 'TEMPORIZADOR',
				requireAuth: true
			}
		}, //西班牙语第六步
		{
			path: '/spain/stepSeven',
			name: 'Spainstepseven',
			component: resolve => require(['@/pages/spain/stepSeven'], resolve),
			meta: {
				title: 'PASO 4: LEER EL RESULTADO',
				requireAuth: true
			}
		}, //西班牙语第七步
		{
			path: '/spain/stepEight',
			name: 'Spainstepeight',
			component: resolve => require(['@/pages/spain/stepEight'], resolve),
			meta: {
				title: 'RESULTADO',
				requireAuth: true
			}
		}, //西班牙语第八步
		{
			path: '/spain/stepNight',
			name: 'Spainstepnight',
			component: resolve => require(['@/pages/spain/stepNight'], resolve),
			meta: {
				title: 'INSTRUCCIONES PARA EL USUARIO',
				requireAuth: true
			}
		}, //西班牙语检测结果
	]
})
